import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminAuthToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminAuthToken')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export const usageReportsAPI = {
  getUniqueCustomers: (days = 30) => 
    api.get('/api/usage-reports/unique-customers', { params: { days } }),
  
  getMessageStats: (days = 30) => 
    api.get('/api/usage-reports/message-stats', { params: { days } }),
  
  getUsageMetrics: (days = 30) => 
    api.get('/api/usage-reports/metrics', { params: { days } }),
}


